export default `
  uniform vec3 uColor1;
  uniform vec3 uColor2;
  uniform vec3 uShine1;
  uniform vec3 uShine2;
  uniform vec2 uResolution;
  uniform float uAngles[ANGLE_NUM];
  uniform float uColorScale;
  uniform float uIsStar;

  varying vec2 vUv;
  varying float vAngle;
  varying float vAlpha;
  const float PI = 3.14159265359;
  const float PI2 = PI * 2.0;

  void main(){
    vec2 st = gl_FragCoord.xy / uResolution;
    vec3 color = mix(uColor1, uColor2, st.x);

    #if TYPE == 0
    color *= 2.8;
    #endif

    vec3 shineColor;
    float shineFactor;
    float shineFactor2;
    float darkFactor;

    #if IS_STAR == 1

    for(int i = 0; i < ANGLE_NUM; i++){
      float angle = fract(vAngle / PI2 + uAngles[i]);
      shineFactor = smoothstep(1.0, 0.95, angle);
      shineFactor2 = smoothstep(0.995, 0.95, angle);

      shineColor = mix(uShine1, uShine2, shineFactor);

      #if TYPE == 0
      shineColor *= 1.4;
      #endif
      color = mix(shineColor, color, shineFactor2);

      darkFactor = smoothstep(0.0, 0.05, angle);

      color = mix(color * 0.5, color, darkFactor);
    }
    #endif

    float smoothEdge = smoothstep(0.46, 0.38, abs(vUv.x - 0.5));

    gl_FragColor = vec4(color, vAlpha * smoothEdge);
  }
`
